import BaseApi from '@/services/api/BaseApi';

export default class UserApi extends BaseApi {
    protected type: string = 'users';
}
